import { gallery, h, img, p } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'frc-2021-off-season',
  title: 'FRC 2021 — Off Season',
  summary: 'Drivetrain subsystem and parametric design.',
  cover: { src: '/assets/FRC-OffSeason.png', alt: 'CAD of the FRC off-season robot' },
  tags: ['CAD'],
  order: 8,
  blocks: [
    p('Due to the nature of COVID, the lockdown limited what our FRC team could do for the off-season. I participated in design training which consisted of creating a drivetrain subassembly for the 2020 season robot. Traditionally, our team generally uses six wheel tank drivetrain which was what I defaulted to.'),

    h('Gearbox'),
    p('Using a design calculator I determined what my gear ratios should be so that I could design the gearbox.'),
    gallery([
      {
        src: '/assets/FRC-OS-Jvn.png',
        alt: 'Design calculator used to work out the drivetrain gear ratios',
      },
      {
        src: '/assets/FRC-OS-Gearbox.png',
        alt: 'CAD model of the drivetrain gearbox',
      },
    ]),

    h('Sideplate'),
    p('The sideplate is one of the first parts that I worked on for the drivetrain. Generally, this part is easiest to start off with first because you can link other dependencies and relations to it.'),
    img('/assets/FRC-OS-Sideplate.png', 'CAD model of the drivetrain sideplate'),

    h('Bellypan'),
    img('/assets/FRC-OS-Bellypan.png', 'CAD model of the drivetrain bellypan'),

    h('An Unfinished Project'),
    p('During the off-season, I also worked on creating an elevator subsystem and, although I didn\'t get to finishing it there were a few important takeaways from this project. The frame of the elevator was made using parametric sketch and multibody parts; meaning the main frame and design of the elevator was made based off a single sketch. The benefits of having a parametric sketch when the dimensions need to be changed is that the parts are reflexive, so changes in one sketch could update the features across the assembly. For this project, I implemented multibody in Solidworks, which in essence, allows me to create parts for assembly from the individual solid bodies of a part.'),
    gallery([
      {
        src: '/assets/FRC-OS-ElevatorSketch.png',
        alt: 'Parametric sketch that drives the elevator frame geometry',
      },
      {
        src: '/assets/FRC-OS-Elevator.png',
        alt: 'CAD model of the elevator subsystem built as multibody parts from the sketch',
      },
    ]),
  ],
}

export default project
